import { T, TFunction } from '@transifex/react'
import React from 'react'
import { isReturn } from '../../../functions/sale'
import { SaleStatus } from '../../../models/sale.constants'
import { ReduxCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'

export enum TooltipContext {
  DISCOUNT = 'Discount',
  PROMOTION = 'Promo code',
}

const tooltipMessageFactory = (t: TFunction, context: TooltipContext) => {
  return (title: string, message: string) => {
    return {
      title: t(title, { _context: `${context} disabled tooltip header text` }),
      message: (
        <T _str={message} _context={`${context} disabled tooltip message`} />
      ),
    }
  }
}

export const getDisabledTooltipMessage = (
  t: TFunction,
  currentSale: ReduxCurrentSale,
  context: TooltipContext
) => {
  const generateTooltipMessage = tooltipMessageFactory(t, context)

  const translatedMessage =
    context === TooltipContext.DISCOUNT
      ? t('Discount can’t be added because the sale is being returned.')
      : t('Promo code can’t be added because the sale is being returned.')

  if (isReturn(currentSale)) {
    return generateTooltipMessage(
      t('Sale is being returned'),
      translatedMessage
    )
  }

  if (!currentSale.status) {
    return
  }

  const messages: Partial<
    Record<
      SaleStatus,
      {
        title: string
        message: React.JSX.Element
      }
    >
  > = {
    [SaleStatus.AWAITING_DISPATCH]: generateTooltipMessage(
      'Sale has items for fulfillment',
      `${context} can’t be added to the sale because there are items for fulfillment.`
    ),
    [SaleStatus.AWAITING_PICKUP]: generateTooltipMessage(
      'Sale has items for fulfillment',
      `${context} can’t be added to the sale because there are items for fulfillment.`
    ),
    [SaleStatus.ACCOUNT_SALE]: generateTooltipMessage(
      'Sale is on account',
      `${context} can’t be added because the sale is on account.`
    ),
    [SaleStatus.LAYBY_SALE]: generateTooltipMessage(
      'Sale is on layby/layaway',
      `${context} can’t be added because the sale is on layby/layaway.`
    ),
  }

  return messages[currentSale.status]
}
